module.exports = __webpack_public_path__ + "img/5-5.f2481040.svg";